import { apis } from '@doltech/core/lib/api/api.config';
import { apiUrls } from '@doltech/core/lib/api/api.urls';
import cl from 'classnames';
import * as React from 'react';
import { useClickAway } from 'react-use';
import { Transforms } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';
import styled from 'styled-components';

import { HyperLinkInput } from '../../../../DolEditor/elements/hyper-link/components/HyperLinkInput';
import { DeleteElementButtonAndActions } from '../../../shared-components/DeleteElementButtonAndActions';
import { Nothing } from '../../../shared-components/Nothing';
import { ieltsCalendarComputedBasedTransforms } from '../../SpecialObject/IeltsCalendar/ComputerBased/transforms';

export const fetchVocabViaUrl = (url: string) =>
  apis.onlineTest.post(apiUrls.onlineTest.VOCAB, { url });

const Wrapper = styled.div`
  position: relative;
`;

export const UploadVocabListNews = (props) => {
  const { element, attributes, children } = props;
  const editor = useSlateStatic();

  const [isSelected, setSelected] = React.useState(false);
  const mainRef = React.useRef();

  useClickAway(mainRef, () => setSelected(false));

  if (element?.isPreview) {
    return <Nothing {...props} />;
  }

  return (
    <Wrapper
      id={element.id as string}
      key={element.id}
      ref={mainRef}
      contentEditable={false}
      onClick={() => setSelected(true)}
      className={cl('upload-vocab-list-news', element.id)}
      {...attributes}
    >
      {children}
      <HyperLinkInput
        title="Vocab list"
        onMouseDown={() => {}}
        onClose={() => {
          ieltsCalendarComputedBasedTransforms.removeNodeById(editor, element.id);
        }}
        onApplyLink={(url) => {
          ieltsCalendarComputedBasedTransforms.updateUrl({ url, elementId: element.id, editor });
        }}
        apiFn={async (urlString) => {
          const res = (await fetchVocabViaUrl(urlString)) as any;
          const path = ReactEditor.findPath(editor as any, element);
          if (res.data) {
            Transforms.setNodes(editor, { ...res.data, url: urlString }, { at: path });
          }

          return res;
        }}
        mode="inline"
      />

      <DeleteElementButtonAndActions
        visible={isSelected}
        onClick={() => ieltsCalendarComputedBasedTransforms.removeNodeById(editor, element.id)}
      />
    </Wrapper>
  );
};
